<template>
  <tk-container
    disableScroll
    class="h-full"
    :status="loading ? 'loading' : false"
  >
    <!-- 登录页面 -->
    <div
      v-if="!error"
      class="flex flex-col p-15 h-full relative"
    >
      <div class="flex flex-col justify-between flex-grow px-15">
        <!-- 上 -->
        <div>
          <!-- 问候 -->
          <div
            class="text-24 font-bold line-height-44 color-black mt-80"
          >
            您好,<br>欢迎来到红商学院！
          </div>
          <van-divider />
          <div class="color-black text-14">
            即将登录红商学院，请确认是本人操作
          </div>
          <div class="text-gray text-12 mt-4">
            ·我们会获取您的昵称、头像等信息
          </div>
          <!-- 按钮 -->
          <div
            class="mt-70 w-full"
          >
            <div>
              <van-button
                class="w-full"
                @click="login"
                color="linear-gradient(270deg, #FC966E 0%, #F96654 100%)"
              >
                授权登录
              </van-button>
            </div>
            <div class="mt-22">
              <van-button
                class="w-full"
                type="default"
                @click="$back()"
              >
                取消
              </van-button>
            </div>
          </div>
        </div>
        <!-- 下 -->
        <div
          class="items-center justify-start text-12 flex pb-5"
        >
          <van-popover
            v-model="showPop"
            theme="dark"
            placement="top-start"
          >
            <div class="text-10 px-10 py-2">
              请阅读并同意协议
            </div>
            <template #reference>
              <van-checkbox
                v-model="checked"
                class="color-black ml-10"
                checked-color="#FC6554"
                icon-size="12px"
              />
            </template>
          </van-popover>
          <div class="ml-6">
            已阅读并同意
            <span
              class="cursor-pointer text-orange"
              @click="$push('/article/protocol')"
            >《用户协议》</span>
            和
            <span
              class="cursor-pointer text-orange"
              @click="$push('/article/protocol')"
            >《隐私政策》</span>
          </div>
        </div>
      </div>
    </div>
    <div class="flex-center" v-else>
      <van-empty image="error" :description="error" class="mt-100" />
    </div>
  </tk-container>
</template>

<script>
import { Dialog } from 'vant'
import config from '../../config.js'
export default {
  data () {
    return {
      checked: false,
      showPop: true,
      fromPath: '',
      loading: false,
      qrRecordId: '',
      error: '',
    }
  },
  watch: {
    checked (newVal, oldVal) {
      this.showPop = (this.$tkUa.isAndroid || this.$tkUa.isIos) ? !newVal : false
    }
  },
  beforeRouteEnter (to, from, next) {
    // 判断是否为手机端
    next(vm => {
      vm.fromPath = from.fullPath
      vm.showPop = vm.$tkUa.isAndroid || vm.$tkUa.isIos
      vm.checked = false
    })
  },
  mounted () {
    this.init()
  },
  methods: {
    // | 初始化
    async init () {
      const { type, state } = this.$route.query
      if (!type) {
        this.error = '参数错误，请核实链接的有效性'
        return
      }
      if (type === 'login') {
        return
      }
      this.loading = true
      if (type !== 'scan' && type !== 'login') {
        this.loading = false
        this.error = '参数错误，请核实链接的有效性'
        return
      }
      if (!state) {
        this.loading = false
        this.error = '参数缺失，请重新扫码登录'
        return
      }
      if (!this.$tkUa.isWechat) {
        this.loading = false
        this.error = '请在微信中打开'
        return
      }
      let list = await this.$tkParse.getList('/classes/qrCodeRecord', {
        params: {
          limit: 1,
          where: {
            state: state
          }
        }
      })
      if (!list.length) {
        this.loading = false
        this.error = '二维码有误，请重新扫码登录'
        return
      }
      if (list[0].status !== '待扫') {
        this.loading = false
        this.error = '二维码已失效，请重新扫码登录'
        return
      }
      if (new Date().getTime() - list[0].timestamp > 1000 * 60 * 5) {
        this.loading = false
        this.error = '二维码已过期，请重新扫码登录'
        return
      }
      this.qrRecordId = list[0].objectId
      this.loading = false
    },
    // | 登录
    login () {
      if (!this.checked) {
        Dialog.alert({
          title: '提示',
          message: '请先阅读并同意用户协议、隐私政策',
          showCancelButton: true,
          confirmButtonText: '同意',
          confirmButtonColor: '#F8604E',
        }).then(() => {
          this.checked = true
          this.wxLogin()
        }).catch(() => {
          this.checked = false
        })
        return
      }
      this.wxLogin()
    },
    // 微信授权
    wxLogin () {
      const { type } = this.$route.query
      let url = encodeURIComponent(window.location.origin + (type === 'scan' ? `/auth/blank?type=scan&qrRecordId=${this.qrRecordId}` : this.fromPath))
      let callbackUrl = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${config.mpAppid}&redirect_uri=${url}&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect`
      window.location.href = callbackUrl
    }
  }
}
</script>

<style scoped lang="scss">
::v-deep(.van-button) {
  border-radius: 8px !important;
}
</style>
